import { Table, TableBody, TableCell, TableHead, TableRow, Grid, Paper, Checkbox } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useEffect, useState } from 'react';
import Button from '../../UI/Button';
import { dateFormat } from '../../../util/DateUtil';
import Loading from '../../UI/Loading';
import { findByUnregistered } from './api-dia-nao-letivo-serie';
import { errorMessage } from '../../../util/ConfirmAlertUtil';

const useStyles = makeStyles({
    container: {
        padding: '10px',
    },
});

const DiaNaoLetivoSerieTableAdding = ({
    handleSave,
    serie,
    isLoadingAction,
    setIsAdding
}) => {
    const classes = useStyles();
    const [listDiaNaoLetivo, setListDiaNaoLetivo] = useState([]);
    const [listDiaNaoLetivoSelected, setListDiaNaoLetivoSelected] = useState([]);
    const [isLoading, setIsLoading] = useState(false);

    useEffect(() => {
        if (serie && serie.codSerie) {
            setIsLoading(true);
            findByUnregistered(serie.codSerie).then((data) => {
                if (data.error) {
                    errorMessage(data.message);
                } else {
                    setListDiaNaoLetivo(data);
                }
                setIsLoading(false);
            })
        }

    }, [serie]);

    const handleChange = (event, diaNaoLetivo) => {
        if (event.target.checked) {
            setListDiaNaoLetivoSelected((prevState) => ([
                ...prevState,
                diaNaoLetivo
            ]));
        } else {
            setListDiaNaoLetivoSelected((prevState) => prevState.filter((ps) => ps.codigo !== diaNaoLetivo.codigo));
        }
    }

    const selectAll = () => {
        setListDiaNaoLetivoSelected(listDiaNaoLetivo);
    }

    const deselectAll = () => {
        setListDiaNaoLetivoSelected([]);
    }

    return (
        <Grid
            container
            component={Paper}
            className={classes.container}
            spacing={3}
        >
            <Grid>
                <Button
                    onClick={() => setIsAdding(false)}
                >
                    Voltar
                </Button>
            </Grid>
            {listDiaNaoLetivo.length > 0 &&
                <>
                    <Grid>
                        <Button
                            disabled={isLoadingAction}
                            onClick={() => handleSave(listDiaNaoLetivoSelected)}
                        >
                            Adicionar
                        </Button>
                    </Grid>

                    <Grid>
                        <Button
                            disabled={isLoadingAction}
                            onClick={selectAll}
                        >
                            Marcar Todos
                        </Button>
                    </Grid>
                    <Grid>
                        <Button
                            disabled={isLoadingAction}
                            onClick={deselectAll}
                        >
                            Desmarcar Todos
                        </Button>
                    </Grid>
                </>
            }
            {isLoading ?
                <Grid
                    container
                    justifyContent='center'
                >
                    <Loading description="Carregando Dias não Letivo" />
                </Grid>
                :
                <>
                    {listDiaNaoLetivo.length > 0 ?
                        <Table size="small" aria-label="a dense table">
                            <TableHead>
                                <TableRow>
                                    <TableCell>Ações</TableCell>
                                    <TableCell>Data</TableCell>
                                    <TableCell>Descrição</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {console.log(listDiaNaoLetivoSelected)}
                                {listDiaNaoLetivo.map((diaNaoLetivo) => (
                                    <TableRow key={diaNaoLetivo.codigo}>
                                        <TableCell>
                                            <Checkbox
                                                checked={listDiaNaoLetivoSelected.some((dnl) => dnl.codigo === diaNaoLetivo.codigo)}
                                                onChange={(event) => handleChange(event, diaNaoLetivo)}
                                                color="primary"
                                            />
                                        </TableCell>
                                        <TableCell>{dateFormat(diaNaoLetivo.data)}</TableCell>
                                        <TableCell>{diaNaoLetivo.descricao}</TableCell>

                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table> :
                        <p>Todas as datas já foram cadastradas.</p>
                    }

                </>
            }
        </Grid>
    );
}

export default DiaNaoLetivoSerieTableAdding;